
import React from 'react';
import { Input } from '../../../../../components/ui/input';
import { Checkbox } from '../../../../../components/ui/checkbox';
import { X } from 'lucide-react';
import { BaseFieldPreviewProps } from './previewUtils';
import { handleAddOption, handleRemoveOption, handleOptionLabelChange } from './previewUtils';

const CheckboxFieldPreview: React.FC<BaseFieldPreviewProps> = ({ field, renderDescription, onUpdateOptions }) => {
  if (!field.options) return null;
  
  return (
    <div>
      {renderDescription()}
      <div className="space-y-2">
        {field.options.map((option: string, index: number) => (
          <div key={`option-${index}`} className="flex items-center">
            <div className="flex items-center space-x-2 flex-1">
              <Checkbox disabled id={`checkbox-${index}`} />
              {onUpdateOptions ? (
                <Input 
                  value={option}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOptionLabelChange(index, e.target.value, field.options!, onUpdateOptions)}
                  className="flex-1"
                />
              ) : (
                <span>{option}</span>
              )}
            </div>
            {onUpdateOptions && (
              <button 
                onClick={() => handleRemoveOption(index, field.options!, onUpdateOptions)}
                className="text-gray-500 hover:text-gray-700 p-1"
                disabled={field.options && field.options.length <= 2}
              >
                <X className="h-4 w-4" />
              </button>
            )}
          </div>
        ))}
        
        {onUpdateOptions && (
          <div className="flex items-center mt-2">
            <div className="flex items-center space-x-2 text-gray-500 cursor-pointer">
              <Checkbox disabled />
              <span className="text-sm" onClick={() => handleAddOption(field.options!, onUpdateOptions)}>
                Option hinzufügen
              </span>
            </div>
            {/* <span className="mx-2 text-gray-500">oder</span>
            <button 
              className="text-blue-500 hover:text-blue-700 text-sm"
              onClick={() => handleAddOption(field.options!, onUpdateOptions)}
            >
              "Sonstiges"
            </button> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckboxFieldPreview;
